import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getCurrentInquiryAsync } from "./actions";
import { ICurrentInquiryState } from "./slice";

type Reducer = (builder: ActionReducerMapBuilder<ICurrentInquiryState>) => void;

export const getCurrentInquiryReducer: Reducer = (builder) => {
  builder.addCase(getCurrentInquiryAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getCurrentInquiryAsync.fulfilled, (state, actions) => {
    state.isLoading = false;
    state.item = actions.payload;
  });

  builder.addCase(getCurrentInquiryAsync.rejected, (state) => {
    state.isLoading = false;
    state.item = null;
  });
};
